import _classCallCheck from "/opt/app/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/app/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/app/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/opt/app/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import React from 'react';
import { Form } from 'react-bootstrap';
import { Field } from 'react-final-form';
import { FieldLabel } from './FieldLabel';
import { FieldError } from './FieldError';

var PasswordField = function () {
  var PasswordField = /*#__PURE__*/function (_React$Component) {
    _inherits(PasswordField, _React$Component);

    var _super = _createSuper(PasswordField);

    function PasswordField() {
      _classCallCheck(this, PasswordField);

      return _super.apply(this, arguments);
    }

    _createClass(PasswordField, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            name = _this$props.name,
            isRequired = _this$props.isRequired,
            isReadonly = _this$props.isReadonly,
            initialValue = _this$props.initialValue,
            placeholder = _this$props.placeholder,
            label = _this$props.label;
        return React.createElement(Field, {
          name: name,
          initialValue: initialValue,
          render: function render(_ref) {
            var input = _ref.input,
                meta = _ref.meta;
            return React.createElement(Form.Group, {
              controlId: name
            }, React.createElement(FieldLabel, Object.assign({}, label, {
              isRequired: isRequired
            })), React.createElement(Form.Control, Object.assign({}, input, {
              readOnly: isReadonly,
              type: 'password',
              placeholder: placeholder,
              isInvalid: FieldError.isInvalid(meta)
            })), React.createElement(FieldError, {
              error: meta.error
            }));
          }
        });
      }
    }]);

    return PasswordField;
  }(React.Component);

  PasswordField.defaultProps = {
    isReadonly: false,
    isRequired: false
  };
  return PasswordField;
}();

export { PasswordField };